import styled from '@emotion/styled'

import { useProfile } from 'src/hooks/use-profile'
import { Avatar } from 'src/system/ui/image/Avatar'
import { AbsoluteLink } from 'src/system/ui/link/AbsoluteLink'

export function FaceitProfile() {
  const { profile } = useProfile('cache-first')
  const faceit = profile?.faceit
  if (!faceit) return null
  const { name, avatarUrl } = faceit
  return (
    <div>
      <ProfileLink
        to={`https://www.faceit.com/players/${encodeURIComponent(name)}`}
        newTab
        disableStyles
      >
        <Container>
          <StyledAvatar src={avatarUrl} />
          <Username>{name}</Username>
        </Container>
      </ProfileLink>
    </div>
  )
}

const ProfileLink = styled(AbsoluteLink)`
  display: inline-block;
  &:hover {
    opacity: 0.85;
  }
`

const Username = styled.span`
  font-family: ${(props) => props.theme.d.font.primary};
  font-style: normal;
  font-weight: bold;
  color: ${(props) => props.theme.d.colors.text.secondary};
`

const StyledAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  margin-right: 20px;
`

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 25px;
`
